
export default {
  ms2kmh(ms) {
    return this.round(ms * 3.6, 0);
  },

  deg2wind(deg) {
    let value = parseFloat(deg);
    if (value <= 11.25)
      return 'N';
    value -= 11.25;
    const allDirections = [
      'NNE', 'NE', 'ENE', 'E', 'ESE',
      'SE', 'SSE', 'S', 'SSW', 'SW',
      'WSW', 'W', 'WNW', 'NW', 'NNW', 'N'
    ];
    let dIndex = parseInt(value / 22.5);
    return allDirections[dIndex] ? allDirections[dIndex] : 'N';
  },

  deg2arrow(deg) {
    deg = parseFloat(deg);
    const arrows = [
      '↑', '↗', '→', '↘', '↓', '↙', '←', '↖'
    ];
    let degs_per_arrow = parseInt(360 / arrows.length);
    let index = this.round(deg / degs_per_arrow);
    if (index >= 8)
      index = 0;
    return arrows[index] ? arrows[index] : '↑';
  },

  date2weekday(dt) {
    // Date() → "Dimecres"
    let str = dt.toLocaleDateString('ca-ES', {
      weekday: 'long',
    }) || '';
    return str[0].toUpperCase() + str.slice(1)
  },

  date2monthname(dt) {
    // Date() → "Dimecres"
    let str = dt.toLocaleDateString('ca-ES', {
      month: 'long',
    }) || '';
    return str[0].toUpperCase() + str.slice(1)
  },

  date2locale_date(dt) {
    // Date() → "Dimecres, 29 de juny"
    let str = dt.toLocaleDateString('ca-ES', {
      month: 'long',
      weekday: 'long',
      day: 'numeric'
    }) || (''+dt);
    return str[0].toUpperCase() + str.slice(1)
  },

  date2locale_datetime(dt) {
    // Date() → "Dimecres, 29 de juny"
    let str = dt.toLocaleDateString('ca-ES', {
      month: 'long',
      weekday: 'long',
      day: 'numeric',
      hours: 'numeric',
      minutes: 'numeric',
    }) || (''+dt);
    return str[0].toUpperCase() + str.slice(1)
  },

  date2locale_date_yymmdd(dt) {
    // Date() → "Dimecres, 29 de juny de 2022"
    let str = dt.toLocaleDateString('ca-ES', {
      year: 'numeric',
      month: 'long',
      weekday: 'long',
      day: 'numeric'
    }) || (''+dt);
    return str[0].toUpperCase() + str.slice(1)
  },

  date2locale_date_yymm(dt) {
    // Date() → "Juny de 2022"
    let str = dt.toLocaleDateString('ca-ES', {
      month: 'long',
      year: 'numeric',
    }) || (''+dt);
    return str[0].toUpperCase() + str.slice(1)
  },

  date2isoformat_tz(d) {
    // Date() → "2022-08-01T23:30:00.0000Z"
    return (d.getFullYear()
          + "-" + ("0"+(d.getMonth()+1)).slice(-2)
          + "-" + ("0" + d.getDate()).slice(-2)
          + "T" + ("0" + d.getHours()).slice(-2)
          + ":" + ("0" + d.getMinutes()).slice(-2));
  },

  prediction_value2icon(val) {
    // Meteocat API value to mdi icon name
    const icons = {
      1:  'mdi-weather-sunny',
      2:  'mdi-weather-partly-cloudy',
      3:  'mdi-weather-partly-cloudy',
      4:  'mdi-weather-cloudy',
      5:  'mdi-weather-rainy',
      6:  'mdi-weather-pouring',
      7:  'mdi-weather-partly-rainy',
      8:  'mdi-weather-lightning-rainy',
      9:  'mdi-weather-hail',
      10: 'mdi-weather-snowy-heavy',
      11: 'mdi-weather-fog',
      12: 'mdi-weather-fog',
      13: 'mdi-weather-partly-snowy',
      20: 'mdi-weather-partly-cloudy',
      21: 'mdi-weather-cloudy',
      22: 'mdi-weather-hazy',
      23: 'mdi-weather-partly-rainy',
      24: 'mdi-weather-partly-lightning',
      25: 'mdi-weather-partly-snowy',
      26: 'mdi-weather-partly-snowy',
      27: 'mdi-weather-snowy',
      28: 'mdi-weather-partly-snowy',
      29: 'mdi-weather-partly-snowy-rainy',
      30: 'mdi-weather-snowy-rainy',
      31: 'mdi-weather-partly-rainy',
      32: 'mdi-weather-rainy',
    };
    return icons[val] || icons[1];
  },

  prediction_date2locale_date(raw_date) {
    // "2022-06-29Z" → "Dimecres, 29 de juny"
    return this.date2locale_date(new Date(raw_date.replace('Z','')));
  },

  prediction_value2iconurl(val) {
    return `http://static-m.meteo.cat/assets-w3/images/meteors/estatcel/${val}.svg`;
  },

  lunar_fase2text(fase_id) {
    const table = {
      0: 'Lluna nova',
      1: 'Lluna nova visible',
      2: 'Quart creixent',
      3: 'Lluna gibosa creixent',
      4: 'Lluna plena',
      5: 'Quart minvant',
      6: 'Lluna minvant',
      7: 'Lluna nova',
    };
    return table[fase_id] || table[0];
  },

  lunar_fase2icon(fase_id) {
    const table = {
      0: 'mdi-moon-new',
      1: 'mdi-moon-waxing-crescent',
      2: 'mdi-moon-first-quarter',
      3: 'mdi-moon-waxing-gibbous',
      4: 'mdi-moon-full',
      5: 'mdi-moon-waning-gibbous',
      6: 'mdi-moon-last-quarter',
      7: 'mdi-moon-waning-crescent',
    };
    return table[fase_id] || table[0];
  },

  hhmm(dt) {
    // dt is a Date, returns "HH:MM"
    if (typeof(dt) != "object")
      dt = new Date(dt);  // Attempt to transformat dt to Date
    return ((''+dt.getHours()).padStart(2, 0)
          + ':'
          + (''+dt.getMinutes()).padStart(2, 0));
  },

  round(n, decimals) {
    if (n === undefined || n === null)
      return null;
    if (decimals === undefined)
      decimals = 0;
    return n.toFixed(decimals);
  },

  table_format(row) {
    // Copy data and set date format
    let res = {
      ...row,
    };

    // Wind direction
    if (row.wind_dir_avg)
      res.wind_dir_avg = this.deg2wind(res.wind_dir_avg);

    // Round
    for (const key of Object.keys(res))
      if (typeof(res[key]) == 'number')
        res[key] = this.round(res[key], 1);

    return res;
  }
}
